import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import CounterBadge from "@/components/ui/counter-badge";
import { cn } from "@/utils/utils";
import { ProposalSection } from "../types";
import { BlankLegend } from "./BlankLegend";

interface Props {
  sections: ProposalSection[];
  outstandingBySection: Record<string, number>;
  activeSectionId?: string;
  onSelect: (sectionId: string) => void;
}

export const SectionRail: React.FC<Props> = ({
  sections,
  outstandingBySection,
  activeSectionId,
  onSelect
}) => {
  const { t } = useTranslation();
  return (
    <nav
      className="flex flex-col justify-between h-full p-2"
      aria-label={t("contracts.proposals.editor.railLabel")}
      data-test="proposal-section-rail"
    >
      <div className="flex flex-col gap-2">
        <Text variant="smBodySecondary" className="px-2 pt-0.5">
          {t("contracts.proposals.editor.railLabel")}
        </Text>
        <ul className="flex flex-col">
          {sections.map((section) => {
            const outstanding = outstandingBySection[section.id] ?? 0;
            const active = section.id === activeSectionId;
            return (
              <li key={section.id}>
                <button
                  type="button"
                  onClick={() => onSelect(section.id)}
                  aria-current={active ? "true" : undefined}
                  className={cn(
                    "flex w-full items-center gap-2 rounded-lg pl-2 pr-1.5 py-1.5 text-left hover:bg-surface-hover-soft",
                    active && "bg-buttons-nav-item-selected"
                  )}
                  data-test={`proposal-rail-${section.id}`}
                >
                  <Text variant="body" className="flex-1 truncate">
                    {section.title}
                  </Text>
                  {outstanding > 0 ? (
                    <CounterBadge
                      count={outstanding}
                      className="border-transparent bg-badges-warning [&>p]:text-text-warning"
                    />
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      <BlankLegend />
    </nav>
  );
};
